import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Forbidden() {
  return (
    <>
      <SEO 
        title="403 - Adgang nægtet" 
        description="Du har ikke rettigheder til at tilgå denne side hos Fyns - Tømreren ApS." 
        noIndex={true}
      />

      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F5F5] py-20 px-4">
        <div className="max-w-md w-full bg-white p-8 sm:p-10 shadow-sm border border-gray-200 text-center space-y-6">
          <div className="w-20 h-20 bg-[#1F2A37] text-amber-500 flex items-center justify-center text-3xl mx-auto">
            <i className="fa-solid fa-lock"></i>
          </div>
          
          <div className="space-y-2">
            <span className="text-4xl font-extrabold text-[#111111]">403</span>
            <h1 className="text-2xl font-bold text-[#111111]">Adgang nægtet</h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              Du har ikke de nødvendige rettigheder til at tilgå denne ressource.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/"
              className="inline-block bg-[#3A5A40] hover:bg-[#2D4632] text-white px-6 py-3 font-semibold text-sm transition-colors"
            >
              <i className="fa-solid fa-house mr-2"></i>
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
